import { gql } from '@apollo/client';

export const GET_BAGS = gql`
  query bags {
    bags {
      id
      name
      qrCode
      depositAmount
      equipments {
        equipment {
          id
          name
          size
        }
      }
      rentals {
        id
        rentalDate
        returnDate
        rentalComment
        rentalPicture
        returnComment
        returnPicture
        depositPaid
        depositReturned
        user {
          id
          firstName
          lastName
          profile {
            pictureThumbnail
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_BAG_DETAILS = gql`
  query bag($qrCode: String!) {
    bag(qrCode: $qrCode) {
      id
      name
      qrCode
      depositAmount
      equipments {
        equipment {
          id
          name
          description
          size
        }
        comments
        qualityGrade
        picture
        bag {
          id
        }
        history {
          id
          qualityGrade
          picture
          createdAt
        }
      }
      rentals {
        id
        rentalDate
        returnDate
        rentalComment
        rentalPicture
        returnComment
        returnPicture
        depositPaid
        depositReturned
        user {
          id
          firstName
          lastName
          email
          profile {
            pictureThumbnail
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
